module.exports = __webpack_public_path__ + "img/fm.737cf2a2.svg";